/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { apiClient } from '../../../lib/apiClient';

export const getCourtNM = createAsyncThunk('newMexicoCourts/getCourt', async (params) => {
  const { data } = await apiClient.get(`/api/newMexicoCourts/${params.id}`);

  return data;
});

export const updateCourtNM = createAsyncThunk(
  'newMexicoCourts/updateCourt',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.put(`/api/newMexicoCourts/${params.id}`, params);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const getFeesAndCostsNM = createAsyncThunk(
  'newMexicoCourts/getFeesAndCosts',
  async (params) => {
    const { data } = await apiClient.get(`/api/newMexicoCourts/${params.id}/feesAndCosts`);
    return data;
  },
);

export const createCourtNM = createAsyncThunk(
  'newMexicoCourts/createCourt',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post(`/api/newMexicoCourts`, params);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const getListOfAddressesForCourtNM = createAsyncThunk(
  'newMexicoCourts/getListOfAddressesForCourt',
  async (params) => {
    const { data } = await apiClient.post(
      `/api/newMexicoCourts/${params.id}/addresses/filter`,
      params,
    );
    return data;
  },
);

export const addAddressesToCourtNM = createAsyncThunk(
  'newMexicoCourts/addAddressesToCourt',
  async (params) => {
    const { data } = await apiClient.post(`/api/newMexicoCourts/${params.id}/addresses`, params);
    return data;
  },
);

export const removeAddressesFromCourtNM = createAsyncThunk(
  'newMexicoCourts/removeAddressesFromCourt',
  async (params) => {
    const { data } = await apiClient.delete(`/api/newMexicoCourts/${params.id}/addresses`, {
      data: params,
      headers: { 'Content-Type': 'application/json' },
    });
    return data;
  },
);

export const resetFeesAndCostsNewMexico = createAction('newMexicoCourts/resetFeesAndCosts');

const initialState = {
  getCourt: {},
  getFeesAndCosts: null,
  getListOfAddressesForCourt: [],
};

export const newMexicoCourtsSlice = createSlice({
  name: 'newMexicoCourts',
  initialState,
  reducers: {},
  extraReducers: {
    [getCourtNM.fulfilled]: (state, action) => {
      state.getCourt = action.payload.result;
    },
    [getFeesAndCostsNM.fulfilled]: (state, action) => {
      state.getFeesAndCosts = action.payload.result;
    },
    [getListOfAddressesForCourtNM.fulfilled]: (state, action) => {
      state.getListOfAddressesForCourt = action.payload.result;
    },
    [resetFeesAndCostsNewMexico]: (state) => {
      state.getFeesAndCosts = null;
    },
  },
});

export default newMexicoCourtsSlice.reducer;
